import React from 'react'
import styled from 'styled-components'

interface SourceLinkProps {
    content: string
    link: string
    title?: string
    secondary?: boolean
}

function SourceLink({ content, link, title, secondary }: SourceLinkProps) {
    let url = null
    try {
        url = new URL(link)
    } catch (error) {
        return null
    }

    const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.stopPropagation()
    }

    return (
        <Container title={content}>
            <StyledAnchor href={link} target='_blank' onClick={handleClick}>
                <ContentContainer secondary={secondary}>
                    {!secondary ? (
                        <>
                            <Title>{title}</Title>
                            <Content>{url && content}</Content>
                            <Hostname>
                                <Favicon
                                    src={`//f7.allesedv.com/16/${url?.hostname}`}
                                    alt='Favicon'
                                />
                                {url?.hostname}
                            </Hostname>
                        </>
                    ) : (
                        <SecondaryContent>
                            <Favicon src={`//f7.allesedv.com/16/${url?.hostname}`} alt='Favicon' />
                            <span>{url && content}</span>
                        </SecondaryContent>
                    )}
                </ContentContainer>
            </StyledAnchor>
        </Container>
    )
}

export default SourceLink

const Container = styled.div`
    position: relative;
    display: inline-block;

    border-radius: 8px;
    background: ${({ theme }) => theme.body.cardBgColor};

    overflow: hidden;
`

const StyledAnchor = styled.a`
    text-decoration: none;
`

const ContentContainer = styled.div<{ secondary?: boolean }>`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    padding: 0.5rem;
    padding-bottom: 0.75rem;
    font-size: 0.75rem;
    border-radius: 0.5rem;
    cursor: pointer;
    background-color: var(--secondary-background);
    transition: transform 0.2s;
    &:hover {
        background-color: var(--hover-bg);
        transform: translateY(-0.25rem);
    }
`

const Title = styled.div`
    font-size: 1.125rem;
    font-weight: 500;
    color: ${({ theme }) => theme.body.textColorPrimary};
`

const Content = styled.div`
    height: 55px;

    display: flex;
    align-items: center;
    line-height: 1.6;
    color: ${({ theme }) => theme.body.textColorPrimary};
`

const Hostname = styled.span`
    display: block;
    font-size: 0.75rem;
    color: var(--text-secondary);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`

const Favicon = styled.img`
    margin-right: 0.25rem;
    width: 1rem;
    height: 1rem;
    float: left;
    opacity: 0.8;
`

const SecondaryContent = styled.div`
    height: 55px;
    line-height: 1.6;
    color: var(--text-primary);
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${({ theme }) => theme.body.textColorSecondary};
`
